export default __webpack_public_path__ + "static/media/highlightsPageDark.1f3af1b4.png";